export function updateTaskActionsFunc(state, action) {
    state.taskActions = action.payload.value;
    return state;
}
